// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ConnectionStatus {
  Connected = 0,
  Disconnected = 1,
  Heartbeat = 2
}
